function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSwapVertDownActive = function SvgSwapVertDownActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17724",
    d: "M9 3 5 6.99h3V14h2V6.99h3zm0 0L5 6.99h3V14h2V6.99h3z",
    style: {
      fill: "#cecfd7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 18556",
    d: "M16 17.01V10h-2v7.01h-3L15 21l4-3.99zm0 0V10h-2v7.01h-3L15 21l4-3.99z",
    style: {
      fill: "#3f54d9"
    }
  }));
};

export default SvgSwapVertDownActive;